<template>
    <v-card flat>
        <v-overlay :value="loadingBulkPaymentData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar color="bal-gray" dense>
            <v-toolbar-title>{{ `ID ${activeBulkPayment.id}` }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDrawer()">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "Payment info" | t }}
            </v-tab>
            <v-tab-item> <payment-info-tab /></v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "Payment logs" | t }}
            </v-tab>
            <v-tab-item> <payment-logs-tab /></v-tab-item>
            <v-tab style="text-transform: none !important;" v-if="user.role === 'admin'">
                {{ "Bank logs" | t }}
            </v-tab>
            <v-tab-item v-if="user.role === 'admin'"> <bank-logs-tab /></v-tab-item>
            <v-tab style="text-transform: none !important;" v-if="activeBulkPayment.payments && activeBulkPayment.payments.length > 0">
                {{ "Payments" | t }}
            </v-tab>
            <v-tab-item v-if="activeBulkPayment.payments && activeBulkPayment.payments.length > 0"><payments-tab /></v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PaymentInfoTab from "./tabs/payment-info-tab";
import BankLogsTab from "./tabs/bank-logs-tab";
import PaymentLogsTab from "@/views/bulk-payment-history/tabs/payment-logs-tab";
import PaymentsTab from "@/views/bulk-payment-history/tabs/payments-tab";

export default {
    name: "bulk-payment-history-view",
    components: { PaymentLogsTab, PaymentInfoTab, BankLogsTab, PaymentsTab },
    data() {
        return {
            tab: 0,
            tabs: ["Payment info", "Payment logs"]
        };
    },
    computed: {
        ...mapState(["user"]),
        ...mapState('bulkPaymentHistory', ['activeBulkPayment', 'loadingBulkPaymentData'])
    },
    async mounted() {
        document.addEventListener("keydown", this.nextTab);
        await this.getBulkPaymentData({ paymentId: this.$route.params.paymentId });
        if (this.user.role === "admin") this.tabs.push("Bank logs");
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
        if (this.activeBulkPayment.payments && this.activeBulkPayment.payments.length > 0) this.tabs.push("Payments");
    },
    destroyed() {
        document.removeEventListener("keydown", this.nextTab);
    },

    methods: {
        ...mapActions('bulkPaymentHistory', ['getBulkPaymentData']),
        closeDrawer() {
            this.$router.push({ name: "bulk-payments-history-list" });
        },
        nextTab(e) {
            if (e.key === "ArrowLeft") {
                if (this.tab > 0) {
                    this.tab -= 1;
                }
            } else if (e.key === "ArrowRight") {
                if (this.tab + 1 < this.tabs.length) {
                    this.tab += 1;
                }
            }
        }
    }
};
</script>

<style scoped></style>
